import { FormControl, FormGroup } from '@angular/forms';

import { ValidatorHelper } from '@helpers/validators.helper';

type EmailAddressFormType = {
  address: FormControl<string | null>;
  canBeDeleted: FormControl<boolean>;
};
export class EmailAddressForm extends FormGroup<EmailAddressFormType> {
  constructor() {
    super({
      address: new FormControl<string | null>(null, ValidatorHelper.emailValidator()),
      canBeDeleted: new FormControl<boolean>(true)
    });
  }

  public toEmail(): string {
    return this.controls.address.value;
  }
}
